var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 8.04688H5.96875C5.64083 8.04688 5.375 8.31271 5.375 8.64062V18.1406C5.375 18.4685 5.64083 18.7344 5.96875 18.7344H19.0312C19.3592 18.7344 19.625 18.4685 19.625 18.1406V8.64062C19.625 8.31271 19.3592 8.04688 19.0312 8.04688Z",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 8.04688V6.5625C15.4688 6.24756 15.3436 5.94551 15.1209 5.72281C14.8982 5.50011 14.5962 5.375 14.2812 5.375H10.7188C10.4038 5.375 10.1018 5.50011 9.87906 5.72281C9.65636 5.94551 9.53125 6.24756 9.53125 6.5625V8.04688",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 12.0762C17.4595 13.3286 15.0016 13.9866 12.5 13.9836C9.99797 13.9901 7.53913 13.3319 5.375 12.0762",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6094 11.3125H13.3906",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessUnit);
export default __webpack_public_path__ + "static/media/business_unit.e0e838429782a9292a968f1c1b25f256.svg";
export { ForwardRef as ReactComponent };